<template>
  <div class="popups-config">
    <div class="box bg-white">
      <h3>弹窗内容</h3>
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item label="弹窗名称:" prop="popupName">
          <el-input v-model="form.popupName" :disabled="type === 'detail'" style="width: 500px" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="图片背景:" prop="mainImage">
          <el-upload ref="beforeUpload" class="upload-img" :disabled="type === 'detail'" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'mainImage')">
            <div v-if="form.mainImage" class="img f-c-c">
              <img :src="form.mainImage" style="width: 250px;height:180px">
            </div>
            <div v-else class="f-c-c fd-c" style="height:100%;width:250px;">
              <i class="el-icon-plus avatar-uploader-icon" />
              <p>上传图片</p>
            </div>
          </el-upload>
          <div>（建议尺寸: 672 x 500）</div>
        </el-form-item>
        <el-form-item label="弹窗链接:">
          <el-input v-model="popupAttributes.popup_link" :disabled="type === 'detail'" style="width: 600px" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="倒计时截止时间:">
          <el-date-picker v-model="form.countdownEndTime" :disabled="type === 'detail'" type="datetime" placeholder="选择日期" :picker-options="{disabledDate}" />
        </el-form-item>
      </el-form>
    </div>
    <div class="box bg-white">
      <h3>缩略显示</h3>
      <div class="item">
        <div class="title">左下角小图标:</div>
        <div class="content fd-c">
          <el-upload ref="beforeUpload" class="upload-img" style="height: 140px;" action="#" :disabled="type === 'detail'" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'icon_image')">
            <div v-if="popupAttributes.icon_image" class="img f-c-c">
              <img :src="popupAttributes.icon_image" style="height: 140px;width: 140px;">
            </div>
            <div v-else class="f-c-c fd-c" style="height:100%;width:140px;">
              <i class="el-icon-plus avatar-uploader-icon" />
              <p style="margin-top:10px">上传图片</p>
            </div>
          </el-upload>
          <div style="font-size:14px;margin-top:10px">(建议尺寸: 400x400)</div>
        </div>
      </div>
    </div>
    <div class="box bg-white">
      <h3>显示设置</h3>
      <div class="item">
        <div class="title">生效时间:</div>
        <div class="content">
          <el-checkbox v-model="popupRules.is_long" :disabled="type === 'detail'" :true-label="1" :false-label="0" style="margin-right:20px" @change="checkboxChange">长期</el-checkbox>
          <div>
            <el-date-picker v-model="form.effectiveStartTime" :disabled="type === 'detail' || !!popupRules.is_long" type="datetime" placeholder="选择日期" style="margin-right: 14px" :picker-options="{disabledDate}" />
            <el-date-picker v-model="form.effectiveEndTime" :disabled="type === 'detail' || !!popupRules.is_long" type="datetime" placeholder="选择日期" :picker-options="{disabledDate: disabledDateOver}" />
          </div>
        </div>
      </div>
      <div class="item">
        <div class="title">延迟时间:</div>
        <div class="content">
          <el-radio-group v-model="popupRules.is_delay" :disabled="type === 'detail'" @change="e => change(e, 'is_delay')">
            <el-radio :label="0">不延迟</el-radio>
            <el-radio :label="1">延迟</el-radio>
          </el-radio-group>
          <div v-if="popupRules.is_delay">
            <el-input-number v-model="popupRules.delay_time" :disabled="type === 'detail'" controls-position="right" :min="1" :max="10" style="width:120px;margin: 0 6px 0 20px" /> S 弹出
          </div>
        </div>
      </div>
      <div class="item">
        <div class="title">接受对象:</div>
        <div class="content">
          <el-radio-group v-model="popupRules.accept_type" :disabled="type === 'detail'">
            <el-radio :label="0">所有用户</el-radio>
            <el-radio :label="1">未登录用户</el-radio>
            <el-radio :label="2">已登录用户</el-radio>
            <el-radio :label="3">Shopify用户</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item">
        <div class="title">显示页面:</div>
        <div class="content fd-c" style="align-items:flex-start;justify-content:center;">
          <div>
            <el-radio-group v-model="popupRules.display_page_type" :disabled="type === 'detail'">
              <el-radio :label="0">首页</el-radio>
              <!-- <el-radio :label="1">指定页面</el-radio> -->
              <el-radio :label="2">全部页面</el-radio>
            </el-radio-group>
            <span style="margin-left:20px;color:#ccc">(不包含官网页面、登录注册页、个人中心)</span>
          </div>
          <!-- <el-input v-if="popupRules.display_page_type === 1" v-popupRules="popupRules.display_page_path" style="width: 600px;margin-top:10px" placeholder="请输入页面链接"></el-input> -->
        </div>
      </div>
      <div class="item">
        <div class="title">显示屏幕:</div>
        <div class="content">
          
          <el-radio-group v-model="popupRules.display_screen_type" :disabled="true">
            <el-radio :label="0">电脑</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="item">
        <div class="title">显示频率:</div>
        <div class="content">
          <el-radio-group v-model="popupRules.display_frequency" :disabled="true">
            <el-radio :label="0">每次访问网站仅一次</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="foot-btn">
      <el-button @click="$router.back()">{{ type === 'detail' ? '返回' : '取消' }}</el-button>
      <el-button v-if="type !== 'detail'" type="primary" @click="affirm">确认</el-button>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import _ from 'lodash'
import moment from 'moment';

const rules = {
  popupName: [
    { required: true, message: '请输入弹窗名称', trigger: 'blur' },
  ],
  mainImage: [
    { required: true, message: '请选择图片背景', trigger: 'change' }
  ],
}

// 弹窗属性
const popupAttributes = {
  icon_image: '',
  popup_link: ''
}

// 弹窗规则
const popupRules = {
  accept_type: 0, // 接收对象类型：0-所有用户，1-未登录用户，2-已登录用户
  is_long: 1, // 是否长期：0-否，1-是
  display_page_type: 0, // 显示页面类型：0-首页，1-指定页面，2-全部页面
  display_screen_type: 0, // 显示页面类型：显示屏幕类型：0-电脑
  display_frequency: 0, // 显示频率：0
  delay_time: 0, // 延迟时间，单位秒
  is_delay: 0
}

export default {
  data() {
    return {
      form: {},
      popupAttributes: _.cloneDeep(popupAttributes),
      popupRules: _.cloneDeep(popupRules),
      rules,
    }
  },
  computed: {
    type() {
      return this.$route.query.type
    }
  },
  created() {
    if (this.$route.query.type !== 'add') {
      this.getAdPopupsDetail()
    }
  },
  methods: {
    disabledDate(date) {
      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
    },
    disabledDateOver(date) {
      if (this.form.effectiveStartTime) return date.getTime() < this.form.effectiveStartTime
      else return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
    },
    checkboxChange() {
      this.$set(this.form, 'effectiveStartTime', ''),
      this.$set(this.form, 'effectiveEndTime', '')
    },
    change(e, type) {
      if (type === 'is_delay') {
        this.$set(this.popupRules, 'delay_time', +e)
      }
    },
    // 上传
    beforeUpload(file, type) {
      API.signValue({ directory: 'popup/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'popup/')
        formData.append('signValue', data)
        formData.append('fileList', file)
        API.uploadFile(formData).then((result) => {
          if (result.code !== 10000) {
            return this.$message.error(result.message)
          }
          this.$set(type === 'mainImage' ? this.form : this.popupAttributes, type, result.data)
        })
      })
      return false
    },
    getAdPopupsDetail() {
      API.getAdPopupsDetail(this.$route.query.id).then(res => {
        this.form = res.data
        this.popupAttributes = res.data.popupAttributes
        this.popupRules = res.data.popupRules
        this.$set(this.popupRules, 'is_delay', res.data.popupRules.delay_time ? 1 : 0)
        if (this.popupRules.is_long === 1) {
          this.$set(this.form, 'effectiveStartTime', '')
          this.$set(this.form, 'effectiveEndTime', '')
        }
      })
    },
    affirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        if (this.popupRules.is_delay > 0 && !this.popupRules.delay_time) {
          this.$message.warning('请输入延迟时间')
          return
        }
        if (!this.popupRules.is_long && (!this.form.effectiveStartTime || !this.form.effectiveStartTime) ) {
          this.$message.warning('请选择生效时间')
          return
        }
        if (this.form.countdownEndTime && this.form.countdownEndTime < Date.now()) {
          this.$message.warning('倒计时截止时间不能小于当前时间')
          return
        }
        let form = {
          type: 0,
          ...this.form,
          effectiveStartTime: this.form.effectiveStartTime ? moment(this.form.effectiveStartTime).valueOf() : undefined,
          effectiveEndTime: this.form.effectiveStartTime ? moment(this.form.effectiveEndTime).valueOf() : undefined,
          popupAttributes: this.popupAttributes,
          popupRules: this.popupRules
        }
        API.addAdPopups(form).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success(res.message)
          this.$router.back()
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.popups-config {
  min-width: 1200px;
  .box {
    margin-bottom: 10px;
    padding: 20px 10px;

    h3 {
      margin-bottom: 20px;
    }

    .upload-img{
      height: 180px;
      font-size: 14px;
      /deep/ .el-upload {
        border: 1px dotted #999 !important;
        height: 100%;
      }
      .avatar-uploader-icon {
        font-size: 24px;
        font-weight: 600;
      }
      img {
        height: 16  0px;
        object-fit: cover;
      }
    }

    .item {
      display: flex;
      margin-bottom: 22px;

      .title {
        height: 40px;
        width: 150px;
        text-align: right;
        padding-right: 12px;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
      }
      .content {
        display: flex;
        align-items: center;
      }
    }
  }

  .foot-btn{
    position: fixed;
    bottom: 80px;
    left: 52%;
  }
}
</style>

